import React from 'react';
import { Link } from 'react-router-dom';

export default function History0209() {
  return (
    <main className="page">
      <div className="abstracts">
        <div className={`abstracts__container`}>
          <ul className="abstracts__top">
            <li>
              <Link to="/">Головна</Link>
            </li>
            <li>{'>'}</li>
            <li>
              <Link to="/abstracts">Конспекти</Link>
            </li>
            <li>{'>'}</li>
            <li>
              <Link to="/abstracts/history">Історія</Link>
            </li>
            <li>{'>'}</li>
            <li>
              <Link to="/abstracts/history/02-09">02.09</Link>
            </li>
          </ul>
          <h1>Предмет дисципліни. Історія та культура України</h1>
          <div className="abstracts__text">
            <p>Головні питання: Хто ми? Звідки ми?</p>
            <p>Раніше називалось Русь або Давня Русь, а не Київська Русь (придуманий термін)</p>
            <p>
              Українці нащадки трипільців (Вікентій Хвойко). Трипільці не українці, а
              недоцивілізація. Писемність у них була не розвинена та не вживана.
            </p>
            <p>
              М. Хвильовий говорив з іронією про Харків як столицю. Казав, що вона смердюча через
              заводи і є як село.
            </p>
            <p>
              Подивись на селянина, як старанно він обробляє землю, бо знає, що якщо залишить її
              необробленою, то вона миттю забур'яніє. О так і ти, мій друже, обробляй свою душу, бо,
              якщо залишиш її необробленою вона так само вкриється бур’янами. Займайся філософією,
              то і буде обробка твоєї душі (Цицерон)
            </p>
            <p>“Я знаю, що я нічого не знаю, але інші не знають і того” - Сократ</p>
            <p>“Ніхто нічого не може навчити, але всьому можна навчитись”</p>
            <p>Культура - обробка душі, самовиховання</p>
            <ul>
              <li>Культура як обробка землі</li>
              <li>Культура як виховання: трансляція традицій, паралельно самовиховання.</li>
              <li>Культура як навчання </li>
              <li>Культура як розвиток</li>
              <li>Культура як вшанування</li>
            </ul>
          </div>
          <div className="abstracts__text">
            <p>
              Слово "манкурт" є архаїчним та може бути пов'язане з історією та культурою певних
              народів, зокрема з турецькою та курдською історією.
            </p>
            <p>
              Слово "манкурт" також може бути пов'язане з образом з роману Чингіза Айтматова "Біла
              жеребця" (та її екранізацій), де "манкурти" - це люди, які втратили свою пам'ять та
              ідентичність через маніпуляції та вплив зовнішніх сил. Здатний вбити свою матір.
            </p>
            <p>Функції культури: </p>
            <ul>
              <li>Комунікативна: Мамардашвілі машини культури</li>
              <li>Виховна</li>
              <li>
                Регулятивна - різні методи: формальні і неформальні (звичаї: звичаєве право, напр. в
                селах, не за законами)
              </li>
              <li>
                Адаптативна: культура пристосовує до життя у певному історичному середовищі Марк
                Твен Принц і жебрак{' '}
              </li>
              <li>
                Інноваційна: внесення нового - культура, завдання людини: залишатися творцем, а не
                на протилежне ремісник, він вже нового не створе
              </li>
              <li>
                Аксіологічна: Цінності створюються, Вселюдські цінності - Михайло Драгоманов.
                Параджанов, не знаючи укр мови досконально, зняв Тіні забутих предків, що вважається
                найбільш українським екземпляром кінематографу
              </li>
            </ul>
          </div>
        </div>
      </div>
    </main>
  );
}
